import { render, staticRenderFns } from "./paymentsCount.vue?vue&type=template&id=638454e2&"
import script from "./paymentsCount.vue?vue&type=script&lang=js&"
export * from "./paymentsCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports